<script lang="ts" setup>
defineProps<{
  title?: string;
}>();
</script>

<template>
  <main class="d-flex align-items-center justify-content-center min-vh-100 p-3">
    <div class="card shadow-sm login-card w-100">
      <div class="card-body login-card-body d-flex flex-column">

        <!-- Logo / header section -->
        <div class="flex-grow-1 d-flex flex-column align-items-center justify-content-center">
          <img
            src="/images/Blackbox-Logo.png"
            alt="BlackBox"
            class="login-logo"
          />
          <h5 v-if="title" class="fw-semibold mb-0">{{ title }}</h5>
        </div>

        <!-- Content -->
        <div>
          <slot />
        </div>

      </div>
    </div>
  </main>
</template>

<style lang="scss" scoped>
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';

.login-card {
  max-width: 380px;
}

.login-card-body {
  padding: 1.5rem;

  @include media-breakpoint-up(md) {
    min-height: 36rem;
  }
}

.login-logo {
  max-width: 200px;
  height: auto;
  padding-bottom: 1.5em;
  @include media-breakpoint-up(md) {
    max-width: 220px;
  }
}
</style>